import { createMemoryHistory, createBrowserHistory } from 'history';

const history = typeof window === "undefined"?createMemoryHistory():createBrowserHistory();
export default history;
